import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="font-display text-2xl text-[#A1A1AA] animate-pulse">LOADING...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.needs_onboarding) return <Navigate to="/onboarding" replace />;
  if (roles && !roles.includes(user.role)) {
    // Safe redirect: send each role to its actual home (no infinite loop)
    if (user.role === "platform_admin") return <Navigate to="/admin" replace />;
    if (["owner", "manager", "employee"].includes(user.role)) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }
  return children;
}
